import { relatedTopics } from "@/mocks/profile";

const quickNav = [
  { href: "#profile", label: "快速档案", icon: "ri-id-card-line" },
  { href: "#updates", label: "近况动态", icon: "ri-radar-line" },
  { href: "#topics", label: "热议话题", icon: "ri-fire-line" },
  { href: "#details", label: "资料详情", icon: "ri-file-list-3-line" },
  { href: "#social", label: "社交动态", icon: "ri-instagram-line" },
  { href: "#faq", label: "常见问答", icon: "ri-question-line" },
];

export default function ClosingSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-6 md:p-10">
              <p className="font-label text-primary-600 text-xs tracking-[0.25em] mb-3">KEEP BROWSING / 继续浏览</p>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
                不用跳走，本页就能看完
              </h2>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
                关于松下纱荣子的近况、八卦、个人资料、年龄、绯闻与 ins 动态，都集中在同一页面。点击下面的入口可以直接回到对应分区，
                也可以从常被搜索的相关词开始，逐个往下看。
              </p>

              <h3 className="font-label text-xs text-foreground-500 tracking-wide mb-3">分区快速入口</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-6">
                {quickNav.map((n) => (
                  <a
                    key={n.href}
                    href={n.href}
                    className="flex items-center gap-3 px-4 py-3 rounded-md bg-background-50 border border-background-200 hover:border-primary-300 hover:text-primary-700 text-foreground-800 text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className={`${n.icon} text-lg text-primary-600`} aria-hidden="true"></i>
                    {n.label}
                  </a>
                ))}
              </div>

              <h3 className="font-label text-xs text-foreground-500 tracking-wide mb-3">常被搜索的相关词</h3>
              <div className="flex flex-wrap gap-2">
                {relatedTopics.map((t) => (
                  <a
                    key={t}
                    href="#topics"
                    className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs font-label hover:bg-accent-200 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {t}
                  </a>
                ))}
              </div>
            </div>

            <div className="relative min-h-[240px] lg:min-h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20editorial%20still%20life%20with%20soft%20folded%20fabric%20in%20rose%20terracotta%20and%20champagne%20tones%2C%20warm%20dramatic%20side%20lighting%2C%20luxurious%20minimal%20texture%20photography%2C%20calm%20refined%20atmosphere%2C%20no%20readable%20text&width=1000&height=1000&seq=saeko-closing-01&orientation=squarish"
                alt=""
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent lg:bg-gradient-to-r"></div>
            </div>
          </div>
        </div>

        <div className="mt-8 bg-secondary-50 border border-secondary-200 rounded-lg p-5 md:p-6">
          <h2 className="font-heading font-bold text-secondary-900 text-base mb-2.5 flex items-center gap-2">
            <i className="ri-shield-check-line" aria-hidden="true"></i>
            内容说明与免责声明
          </h2>
          <p className="text-secondary-900/85 text-sm leading-relaxed">
            本页为娱乐话题的资料整理与汇总，内容基于公开信息与网络讨论，可能存在说法不一或信息滞后。页面不对任何未经确认的说法作事实保证，
            也不鼓励传播未经核实的内容。若相关当事人认为存在不实之处，欢迎通过页面入口反馈，我们会及时调整。
          </p>
        </div>
      </div>
    </section>
  );
}